import { Component, OnInit } from '@angular/core';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
declare var getHexAscii: any;
@Component({
  selector: 'app-loan-account-details',
  templateUrl: './loan-account-details.component.html',
  styleUrls: ['./loan-account-details.component.css']
})
export class LoanAccountDetailsComponent implements OnInit {
  loanAccounts : any = [];
  loanAcc:string='';
  show:string='page1';
  loanAccDetails:any;
  accountNull:string="yes";
  errorMsg: string;
  isError: boolean;
  constructor(private webService: CallBackEndService,
              private spinnerService: Ng4LoadingSpinnerService,) { 
	  this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
  }

  ngOnInit() {
   }
  loanDetails()
  {
	if (this.loanAcc=== '' || this.loanAcc === undefined ||this.loanAcc=== null) {
      this.accountNull = 'no';
    }else{  
		this.spinnerService.show();
	    const request: IbRequest = new IbRequest();
        let response: IbResponse = null;
        request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName')+this.loanAcc );
	    request.param2 =sessionStorage.getItem('storedUserName'); ;
	    request.param3 =this.loanAcc ;
        this.webService.getResponse(request, 'loanAccountDetails').subscribe((data: IbResponse) => {
		 this.spinnerService.hide();
        if (data !== null && data.status === 'S200') {
		    this.show="page2";
        this.loanAccDetails = data.param5;
        this.isError=false;
             this.errorMsg = '';
          }else if(data!=null){
              this.isError=true;
              this.errorMsg = data.param1;
          }else{
            this.isError=true;
            this.errorMsg = 'Something Went Wrong,Please Try Again Later';
          }
	    });
      }
  }
 removestacctMessage()
  {
    this.accountNull='';
  }
  validateAccNo()
  {
   if (this.loanAcc=== '' || this.loanAcc === undefined ||this.loanAcc=== null) {
      this.accountNull = 'no';
    }
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/loan-account-details/loan-account-details.component.ts